import pagination from "../static/pagination";
import registered from "../static/registered";

const mutations = {
    setResponse: (state, payload) => {
        state.response = payload;
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
    setLoadMore: (state, payload) => {
        state.isLoadMore = payload;
    },
    setFilter: (state, payload) => {
        state.isFilter = payload;
    },
    setQr: (state, payload) => {
        state.qr = payload;
    },
    setDataDevice: (state, payload) => {
        state.dataDevice = payload;
    },
    setDataDeviceTiny: (state, payload) => {
        state.dataDeviceTiny = payload;
    },
    resetDataDeviceTiny: (state) => {
        state.dataDeviceTiny = {};
    },
    setDataDeviceItem: (state, { val, key }) => {
        state.dataDevice[key] = val;
    },
    setNextPagination: (state, payload) => {
        state.pagination.length += payload.length;
        state.pagination.pageNumber++;
        state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
    },
    setRegistered: (state, { key, val }) => {
        state.registered[key] = val;
    },
    resetRegistered: (state) => {
        state.registered = registered();
    },
    setPaketWhatsapp: (state, payload) => {
        state.paketWhatsapp = payload;
    },
    setVoucher: (state, payload) => {
        state.voucher = payload;
    },
    setTagihan: (state, payload) => {
        state.tagihan = payload;
    },
    setListBank: (state, payload) => {
        state.listBank = payload;
    },
    setListPerangkat: (state, payload) => {
        state.listPerangkat = state.listPerangkat.concat(payload.array);
        state.totalPerangkat = payload.count;
    },
    resetListPerangkat: (state) => {
        state.listPerangkat = [];
        state.totalPerangkat = 0;
    },
    setEndItemofPage: (state, payload) => {
        state.endItemofPage = payload;
    },
    resetPagination: (state) => {
        state.pagination = pagination();
    },
    setNextPagination: (state, payload) => {
        state.pagination.length += payload.length;
        state.pagination.pageNumber++;
        state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
    },
    toggleDisplayItem: (state, payload) => {
        let etIdx = state.displayItem.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.displayItem.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.displayItem.splice(etIdx, 1);
        }
    },

    setListPaket: (state, payload) => {
        state.listPaket = state.listPaket.concat(payload.array);
        state.totalListPaket = payload.count;
    },
    resetListPaket: (state) => {
        state.listPaket = [];
        state.totalListPaket = 0;
    },
    setEndPaket: (state, payload) => {
        state.endPaket = payload;
    },
    toggleDisplayPaket: (state, payload) => {
        let etIdx = state.displayPaket.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.displayPaket.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.displayPaket.splice(etIdx, 1);
        }
    },
    setNextPagePaket: (state, payload) => {
        state.pagePaket.length += payload.array.length;
        state.pagePaket.pageNumber++;
        state.pagePaket.offset = state.pagePaket.pageNumber * state.pagePaket.limit;
    },
    resetPagePaket: (state) => {
        state.pagePaket = pagination();
    },

    setListCustomer: (state, payload) => {
        state.listCustomer = payload.array;
    },
    setSelectedCustomer: (state, payload) => {
        state.customer = payload;
        state.customerId = payload.idcustomer;
    },
    setDetailPesan: (state, payload) => {
        state.detailPesan = payload;
    },
    setListPesan: (state, payload) => {
        state.listPesan = state.listPesan.concat(payload.array);
        state.totalFailedPesan = payload.dataCanResend;
				state.totalListPesan = payload.count;
    },
    resetListPesan: (state) => {
        state.listPesan = [];
        state.totalListPesan = 0;
        state.totalFailedPesan = 0;
    },
    setEndPesan: (state, payload) => {
        state.endPesan = payload;
    },
    toggleDisplayPesan: (state, payload) => {
        let etIdx = state.displayPesan.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.displayPesan.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.displayPesan.splice(etIdx, 1);
        }
    },
    setNextPagePesan: (state, payload) => {
        state.pagePesan.length += payload.array.length;
        state.pagePesan.pageNumber++;
        state.pagePesan.offset = state.pagePesan.pageNumber * state.pagePesan.limit;
    },
    resetPagePesan: (state) => {
        state.pagePesan = pagination();
    },

    setListOutlet: (state, payload) => {
        state.listOutlet = state.listPesan.concat(payload.array);
        state.totalOutlet = payload.count;
    },
    resetListOutlet: (state) => {
        state.listOutlet = [];
        state.totalOutlet = 0;
    },
    setEndOutlet: (state, payload) => {
        state.endOutlet = payload;
    },
    toggleDisplayOutlet: (state, payload) => {
        let etIdx = state.displayOutlet.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.displayOutlet.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.displayOutlet.splice(etIdx, 1);
        }
    },
    setNextPageOutlet: (state, payload) => {
        state.pageOutlet.length += payload.array.length;
        state.pageOutlet.pageNumber++;
        state.pageOutlet.offset = state.pageOutlet.pageNumber * state.pageOutlet.limit;
    },
    resetPageOutlet: (state) => {
        state.pageOutlet = pagination();
    },

    setListDeviceTiny: (state, payload) => {
        state.listDeviceTiny = payload;
    },
    setIntegrasiOutlet: (state, payload) => {
        state.integrasiOulet[payload.type] = payload.data;
    },
    setListOutletFree: (state, payload) => {
        state.listOutletFree = payload;
    },
    setDevice: (state, payload) => {
        state.device[payload.type] = payload.data;
    },
    resetDevice: (state) => {
        state.device = {
            nama: "Semua perangkat",
            nomor: null,
            iddevice: null,
        };
    },
    settingOutlet: (state, payload) => {
        state.settingOutlet = payload;
    },
    setDetailTemplatePesan: (state, payload) => {
        state.detailTemplatePesan = payload;
    },
    setHistorySummary: (state, payload) => {
        state.historySummary = {
            averagePerDay: payload.average_per_day,
            recipient: payload.recipient,
            totalCount: payload.total_count,
        };
        state.totalListPesan = payload.total_count;
				state.totalFailedPesan = payload.dataCanResend;
	},
};

export default mutations;
